export enum UploadItemType {
  ADDITIONAL_DOCUMENT = 'ADDITIONAL_DOCUMENT',
  APPLICANT_BACK_OF_LICENSE = 'APPLICANT_BACK_OF_LICENSE',
  APPLICANT_FRONT_OF_LICENSE = 'APPLICANT_FRONT_OF_LICENSE',
  CO_APPLICANT_BACK_OF_LICENSE = 'CO_APPLICANT_BACK_OF_LICENSE',
  CO_APPLICANT_FRONT_OF_LICENSE = 'CO_APPLICANT_FRONT_OF_LICENSE',
  PHOTO_OF_ODOMETER = 'PHOTO_OF_ODOMETER',
  PROOF_OF_INCOME = 'PROOF_OF_INCOME',
  PROOF_OF_INCOME_CO_APPLICANT = 'PROOF_OF_INCOME_CO_APPLICANT',
  PROOF_OF_INSURANCE = 'PROOF_OF_INSURANCE',
  REGISTRATION_CARD = 'REGISTRATION_CARD',
}
